import { Comic, Category, Testimonial, FaqItem } from '@/types';

export const categories: Category[] = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 128 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 96 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 87 },
  { slug: 'mystery', name: '悬疑', icon: 'ri-search-eye-line', count: 64 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 73 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 105 },
  { slug: 'bl', name: '耽美', icon: 'ri-star-line', count: 52 },
  { slug: 'gl', name: '百合', icon: 'ri-flower-line', count: 38 },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '霸道总裁的契约新娘',
    author: '金智慧',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20cover%20art%2C%20elegant%20couple%20in%20modern%20setting%2C%20soft%20warm%20lighting%2C%20delicate%20illustration%20with%20clean%20lines%2C%20pastel%20color%20palette%2C%20beautiful%20character%20design%2C%20webtoon%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '为了拯救家族企业，林小雨不得不嫁给冷酷无情的商业帝王韩辰逸。她以为这只是一场交易婚姻，却不知他早已暗恋她多年。当契约变成真爱，当秘密揭开面纱，他们会走向怎样的结局？一场关于爱情、复仇与救赎的浪漫故事正在上演。',
    rating: 4.8,
    views: 1250000,
    chapters: 86,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    tags: ['总裁', '契约婚姻', '甜宠', '都市'],
  },
  {
    id: '2',
    title: '魔王大人请温柔',
    author: '朴星辰',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20mysterious%20demon%20lord%20with%20dark%20aesthetic%2C%20magical%20elements%20and%20sparkling%20effects%2C%20dramatic%20lighting%2C%20ornate%20costume%20design%2C%20webtoon%20illustration%20style%20with%20rich%20dark%20colors&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '平凡大学生李恩菲意外穿越到异世界，成为了传说中魔王的新娘候选人。但这个魔王似乎和传闻中不太一样——他温柔体贴，还有点天然呆？在魔法与冒险交织的世界里，一段跨越种族的甜蜜恋情悄然萌芽。',
    rating: 4.9,
    views: 980000,
    chapters: 72,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    tags: ['穿越', '异世界', '魔王', '魔法'],
  },
  {
    id: '3',
    title: '暗夜追踪者',
    author: '崔敏俊',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20noir%20detective%20in%20dark%20alley%2C%20dramatic%20shadows%20and%20neon%20accents%2C%20intense%20atmosphere%2C%20stylish%20character%20with%20trench%20coat%2C%20cinematic%20composition%2C%20webtoon%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '前特种部队成员姜赫因一桩悬案重出江湖。在首尔繁华的霓虹灯下，黑暗势力正在悄然蔓延。他必须在正义与复仇之间做出选择，而真相远比想象中更加残酷。',
    rating: 4.7,
    views: 1560000,
    chapters: 94,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    tags: ['悬疑', '动作', '都市', '复仇'],
  },
  {
    id: '4',
    title: '第七夜的谎言',
    author: '尹书妍',
    category: 'mystery',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20art%2C%20dark%20atmospheric%20scene%20with%20moonlight%2C%20mysterious%20female%20character%2C%20gothic%20elements%2C%20intricate%20shadow%20play%2C%20suspenseful%20mood%2C%20elegant%20webtoon%20illustration%20with%20cool%20tones&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '七年前的一场大火带走了她所有的记忆。如今，每当月圆之夜，那些支离破碎的片段便会涌入脑海。究竟是谁在说谎？她决定回到那栋废弃的老宅，揭开被掩埋的真相。',
    rating: 4.6,
    views: 890000,
    chapters: 58,
    status: 'completed',
    updatedAt: '2026-07-15',
    tags: ['悬疑', '心理', '复仇', '惊悚'],
  },
  {
    id: '5',
    title: '我的室友不是人',
    author: '郑多惠',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20playful%20and%20colorful%20scene%20with%20quirky%20characters%2C%20bright%20and%20cheerful%20tone%2C%20humorous%20expression%2C%20cute%20ghost%20character%2C%20webtoon%20illustration%20with%20vibrant%20colors&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '搬进首尔便宜公寓的第一天，苏敏雅就发现她的室友是个活了三百年的鬼魂！这个鬼魂不仅爱追剧、会点外卖，还热衷于给她牵红线。人鬼同居的爆笑日常，就此拉开帷幕！',
    rating: 4.5,
    views: 2100000,
    chapters: 110,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    tags: ['搞笑', '灵异', '日常', '治愈'],
  },
  {
    id: '6',
    title: '重生之豪门千金',
    author: '安艺琳',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20elegant%20woman%20in%20luxurious%20setting%2C%20sophisticated%20fashion%2C%20dramatic%20lighting%20with%20golden%20accents%2C%20emotional%20depth%2C%20beautiful%20webtoon%20illustration%20with%20rich%20warm%20tones&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '前世被继母和妹妹害死的沈知夏，重生回到了十六岁那年。带着前世的记忆，她发誓要夺回属于自己的一切，让那些伤害过她的人付出代价。然而这一次，那个前世与她擦肩而过的男人，却主动走进了她的生命。',
    rating: 4.9,
    views: 1890000,
    chapters: 102,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    tags: ['重生', '复仇', '豪门', '逆袭'],
  },
  {
    id: '7',
    title: '花间秘语',
    author: '韩素英',
    category: 'bl',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20boys%20love%20cover%20art%2C%20two%20elegant%20male%20characters%20in%20traditional%20Korean%20garden%2C%20cherry%20blossoms%2C%20soft%20romantic%20atmosphere%2C%20delicate%20illustration%2C%20pastel%20colors%2C%20webtoon%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '朝鲜时代，贵族公子李润与花匠之子崔秀赫在春日花园中相遇。一个是高高在上的两班少爷，一个是卑微的花匠后裔。在礼教森严的时代，他们能否冲破世俗的枷锁？一段凄美动人的古风之恋。',
    rating: 4.8,
    views: 760000,
    chapters: 64,
    status: 'completed',
    updatedAt: '2026-06-20',
    tags: ['古风', '宫廷', '虐恋', '唯美'],
  },
  {
    id: '8',
    title: '她的秘密花园',
    author: '柳珍珠',
    category: 'gl',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20girls%20love%20cover%20art%2C%20two%20young%20women%20in%20floral%20garden%20setting%2C%20tender%20and%20intimate%20atmosphere%2C%20soft%20sunlight%2C%20pastel%20floral%20colors%2C%20gentle%20and%20romantic%20webtoon%20illustration&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '插画师金艺恩在济州岛开了一家小小的花店。某天，一个失忆的女孩晕倒在她的店门口。艺恩收留了她，却在朝夕相处中渐渐对她产生了不可言说的情感。当女孩的记忆开始恢复，她们的秘密花园还能维持多久？',
    rating: 4.7,
    views: 520000,
    chapters: 48,
    status: 'ongoing',
    updatedAt: '2026-08-01',
    tags: ['治愈', '文艺', '济州岛', '花店'],
  },
  {
    id: '9',
    title: '剑与玫瑰',
    author: '李政勋',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20cover%20art%2C%20female%20knight%20with%20sword%20in%20epic%20battlefield%2C%20rose%20motif%2C%20dramatic%20medieval%20fantasy%20setting%2C%20rich%20armor%20details%2C%20epic%20cinematic%20composition%2C%20webtoon%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '大陆最强的女剑士艾琳，在一次任务中意外解封了被封印千年的玫瑰精灵。从此她的剑上开始绽放花朵，而那个话痨的精灵也赖上了她。剑与魔法、战争与爱情，一段传奇冒险就此展开。',
    rating: 4.6,
    views: 870000,
    chapters: 80,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    tags: ['冒险', '奇幻', '女骑士', '精灵'],
  },
  {
    id: '10',
    title: '校园绯闻',
    author: '张美娜',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20romance%20cover%20art%2C%20young%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20campus%20background%2C%20bright%20and%20youthful%20atmosphere%2C%20warm%20spring%20lighting%2C%20sweet%20webtoon%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '全校第一的学霸和全校最受欢迎的校草，因为一张被偷拍的照片传出了绯闻。为了澄清误会，他们决定假装交往一个月。可是装着装着，好像就真的动心了？',
    rating: 4.7,
    views: 1680000,
    chapters: 92,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    tags: ['校园', '甜宠', '学霸', '青春'],
  },
  {
    id: '11',
    title: '围棋神童',
    author: '赵贤宇',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20drama%20cover%20art%2C%20young%20boy%20playing%20go%20board%20game%2C%20intense%20competition%20scene%2C%20dramatic%20lighting%2C%20psychological%20tension%2C%20minimalist%20Korean%20aesthetic%2C%20webtoon%20illustration&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '天才围棋少年尹泰俊，六岁便击败了职业棋手。然而神童的光环背后，是常人无法想象的孤独与压力。当他遇到同样热爱围棋的对手兼挚友，两个人的命运之线开始纠缠。在黑白棋子的世界里，每一步都是人生。',
    rating: 4.8,
    views: 1040000,
    chapters: 76,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    tags: ['竞技', '成长', '友情', '围棋'],
  },
  {
    id: '12',
    title: '无法抗拒的他',
    author: '崔秀雅',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20attractive%20male%20lead%20in%20modern%20office%20setting%2C%20romantic%20and%20sensual%20atmosphere%2C%20warm%20evening%20lighting%2C%20stylish%20contemporary%20fashion%2C%20webtoon%20illustration%20with%20mature%20vibe&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '职场新人郑多恩遇到了完美上司——姜智勋。他温柔、帅气、能力出众，是公司所有女员工心目中的理想型。多恩告诉自己绝对不能爱上他，可他总是出现在她最需要帮助的时刻。这场危险的办公室恋情，真的能控制住吗？',
    rating: 4.6,
    views: 1350000,
    chapters: 68,
    status: 'completed',
    updatedAt: '2026-07-28',
    tags: ['职场', '办公室恋情', '甜宠', '都市'],
  },
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20female%20avatar%20portrait%2C%20cute%20and%20friendly%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20anime%20inspired%20character%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '资深读者',
    content: '这个网站真的太棒了！漫画资源超级全，更新速度也很快。下拉式阅读体验非常流畅，是我用过最好用的韩漫阅读平台。',
    rating: 5,
  },
  {
    id: '2',
    name: '追更达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20male%20avatar%20portrait%2C%20cool%20and%20stylish%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20anime%20inspired%20character%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: 'VIP会员',
    content: '每天必刷！分类很清晰，找漫画特别方便。而且没有乱七八糟的广告，阅读体验非常纯净。强烈推荐给所有韩漫爱好者！',
    rating: 5,
  },
  {
    id: '3',
    name: '漫画小仙女',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20female%20avatar%20portrait%2C%20sweet%20and%20gentle%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20anime%20inspired%20character%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '忠实粉丝',
    content: '从第一天上线就在用了，漫画质量一直很高，翻译也很到位。推荐了好多朋友一起来看，大家都说好！希望能一直做下去。',
    rating: 5,
  },
];

export const faqs: FaqItem[] = [
  {
    question: '韩漫在线免费网站是什么？',
    answer: '韩漫在线免费是一个专注于韩国漫画的中文阅读平台，收录了海量优质韩漫作品，涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、耽美、百合等多种类型。我们采用下拉式阅读设计，让您像阅读网页一样流畅地浏览漫画，提供最佳的在线阅读体验。',
  },
  {
    question: '如何开始阅读韩国漫画？',
    answer: '非常简单！您可以直接在首页浏览推荐作品和最新更新，也可以通过分类导航找到感兴趣的漫画类型。点击任意漫画封面即可进入详情页，了解作品简介、章节信息和读者评价，然后选择章节开始您的阅读之旅。',
  },
  {
    question: '网站上的漫画都是免费的吗？',
    answer: '是的，我们致力于为广大漫画爱好者提供免费的阅读服务。网站上大部分漫画都可以免费阅读，让您随时随地享受精彩的韩漫故事。我们会持续更新最新章节，确保您不错过任何精彩内容。',
  },
  {
    question: '更新频率怎么样？会及时更新最新章节吗？',
    answer: '我们拥有专业的更新团队，会及时跟进韩国原版漫画的更新进度。热门作品通常会在原版发布后的短时间内同步更新中文版本。您可以通过"最新更新"板块随时查看最新上架的章节。',
  },
  {
    question: '支持手机阅读吗？',
    answer: '当然支持！我们的网站采用响应式设计，完美适配手机、平板和电脑等各类设备。下拉式阅读方式尤其适合手机浏览，您可以随时随地掏出手机，享受流畅的漫画阅读体验。',
  },
  {
    question: '如果遇到喜欢的漫画，可以收藏吗？',
    answer: '您可以将喜欢的漫画加入书签，方便下次继续阅读。我们也会根据您的阅读偏好，在首页为您推荐相似的漫画作品，帮助您发现更多感兴趣的内容。',
  },
];

export const siteStats = {
  totalComics: 12680,
  totalReaders: 8500000,
  dailyUpdates: 320,
  avgRating: 4.7,
};